import axios from "axios";
import { CommentGet, CommentPost } from "../Models/Comment";
import { handleError } from "../Components/Helpers/ErrorHandler";

const api = process.env.REACT_APP_API_URL || "http://localhost:8080/api/";

export const postCommentAPI = async (symbol: string, content: string) => {
  try {
    const data = await axios.post<CommentPost>(api + "comment/" + `${symbol}`, {
      content: content,
    });
    return data;
  } catch (error) {
    handleError(error);
  }
};

export const getCommentAPI = async (symbol: string) => {
  try {
    const data = await axios.get<CommentGet[]>(api + "comment/" + `?Symbol=${symbol}`);
    return data;
  } catch (error) {
    handleError(error);
  }
};
export const deleteCommentAPI = async (id: number) => {
  try {
    const data = await axios.delete(api + "comment/" + `${id}`);
    return data;
  } catch (error) {
    handleError(error);
  }
};
